import {
  IconButton,
  Drawer,
  Portal,
  Circle,
  Float,
  Text,
} from "@chakra-ui/react";
import { useCallback, useState } from "react";
import RawArrowIcon from "vectors/Arrowhead";

import { CartIcon } from "vectors";
import CartSummary from "@features/marketplace/cart/CartSummary";
import { useStores } from "stores/rootStore";
import { observer } from "mobx-react-lite";

const CartIconButton = () => {
  const [open, setOpen] = useState(false);
  const { marketPlaceStore } = useStores();

  const closeDrawer = useCallback(() => {
    setOpen(false);
  }, []);

  return (
    <Drawer.Root size="lg" open={open} onOpenChange={(e) => setOpen(e.open)}>
      <Drawer.Trigger asChild>
        <IconButton
          _hover={{
            backgroundColor: "sidebar.hover",
          }}
          variant="ghost"
          size="sm"
        >
          <CartIcon />
          {marketPlaceStore.cart.length > 0 && (
            <Float offsetY={3} offsetX={1}>
              <Circle size="5" bg="red" color="white">
                <Text fontSize="2xs">{marketPlaceStore.cart.length}</Text>
              </Circle>
            </Float>
          )}
        </IconButton>
      </Drawer.Trigger>
      <Portal>
        <Drawer.Backdrop />
        <Drawer.Positioner>
          <Drawer.Content bg="surface.background">
            <Drawer.Header>
              <IconButton
                variant="ghost"
                size="sm"
                px={1}
                _hover={{
                  backgroundColor: "button.secondary.hover",
                }}
                onClick={closeDrawer}
              >
                <RawArrowIcon boxSize="10px" direction="left" />
              </IconButton>
              <Drawer.Title>
                Your Cart ({marketPlaceStore.cart.length})
              </Drawer.Title>
            </Drawer.Header>
            <Drawer.Body>
              <CartSummary onContinueShopping={closeDrawer} />
            </Drawer.Body>
          </Drawer.Content>
        </Drawer.Positioner>
      </Portal>
    </Drawer.Root>
  );
};

export default observer(CartIconButton);
